import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import Iconify from '@/components/iconify/index.tsx';
import { useState } from 'react';
import { TenantsFormControl } from '@/components/form/TenantsFormControl.tsx';
import { useForceCacheMutation } from '@/api/pickems/postForceCache.ts';

export const UpdateGamesListButton = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [tenants, setTenants] = useState<string[]>([]);

  const {
    mutateAsync: triggerUpdate,
    isError,
    error,
  } = useForceCacheMutation();

  const handleChangeTenants = (value: string | string[]) => {
    setTenants([...(typeof value === 'string' ? value.split(',') : value)]);
  };

  const handleUpdate = async () => {
    await triggerUpdate({ tenants }).finally(() => {
      console.log('finally');
      setAlertOpen(true);

      const timeout = setTimeout(() => {
        setAlertOpen(false);
      }, 3000);

      return () => {
        clearTimeout(timeout);
      };
    });
  };

  return (
    <>
      <Button
        variant='contained'
        startIcon={<Iconify icon='material-symbols-light:cloud-sync-rounded' />}
        onClick={() => setOpen(true)}
        sx={{ mr: 2 }}
      >
        Update Games List for users
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(true)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Update Games List for users
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: '100%', my: 2 }}>
            <Typography sx={{ mb: 2 }}>
              Select tenants to update cache
            </Typography>
            <TenantsFormControl
              value={tenants}
              onChange={handleChangeTenants}
            />
          </Box>
          <Box sx={{ width: '100%' }}>
            {alertOpen && (
              <Alert variant='filled' color={isError ? 'error' : 'success'}>
                {isError ? `Error: ${error?.message}` : 'Success'}
              </Alert>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            variant='contained'
            onClick={handleUpdate}
            autoFocus
            disabled={!tenants.length}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};